import { render, staticRenderFns } from "./StaffCard.vue?vue&type=template&id=6a87ee98&scoped=true"
import script from "./StaffCard.vue?vue&type=script&lang=js"
export * from "./StaffCard.vue?vue&type=script&lang=js"
import style0 from "./StaffCard.vue?vue&type=style&index=0&id=6a87ee98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a87ee98",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Divisions/StaffCard.vue
// module id = 2543
// module chunks = 31